module.exports = __webpack_public_path__ + "img/成功.svg";